import { jsx as _jsx } from "react/jsx-runtime";
import "../../assets/saas/atoms/_switchToogle.scss";
const SwitchToggle = ({ id, onChange, isChecked, disabled = false, }) => {
    const HandleChange = (event) => {
        onChange && onChange(event.target.checked);
    };
    return (_jsx("label", { htmlFor: id, className: "switch", children: _jsx("input", { id: id, type: "checkbox", role: "switch", checked: isChecked, onChange: HandleChange, "aria-checked": isChecked, "aria-disabled": disabled, disabled: disabled }) }));
};
export default SwitchToggle;
